import { isDevMode, NgModule } from '@angular/core';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { readStoredLang, SUPPORTED_LANGS } from './language-config';
import { TranslocoHttpLoader } from './transloco-loader';

/**
 * Transloco root configuration, shared by every app. Import it once per composition root via
 * `importProvidersFrom`; scoped translations are then declared per component or feature module with
 * `provideTranslocoScope`.
 *
 * `prodMode` derives from `isDevMode()` because a lib cannot read an app `environment` file. The two
 * agree across every build configuration here, and `prodMode` only suppresses missing-key and
 * failed-load console warnings - so if they ever diverged, the cost is console noise and nothing more.
 *
 * `defaultLang` is resolved from storage at provide time rather than switched with `setActiveLang`
 * after bootstrap: the app is then never briefly in the wrong language, the very first catalogue
 * request already asks for the selected one, and scopes opened later inherit it with no extra work.
 */
@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: [...SUPPORTED_LANGS],
                defaultLang: readStoredLang(),
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
                // The four apps run `transloco-optimize` over dist/**/assets/i18n, which
                // pre-flattens the translation files. This tells Transloco not to flatten
                // them a second time at runtime. Keep the two in lockstep.
                flatten: {
                    aot: !isDevMode(),
                },
            },
            loader: TranslocoHttpLoader,
        }),
    ],
})
export class TranslocoRootModule {}
